import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Restaumatic$dMenu$dQuery from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic$dMenu$dV2$dCartToOrder from "../Restaumatic.Menu.V2.CartToOrder/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogueQuery from "../Restaumatic.Menu.V2.MenuCatalogueQuery/index.js";
const sum = /* #__PURE__ */ (() => Data$dFoldable.foldlArray(Data$dMoney$dRounded.additiveMoney.add)(0))();
const productPrice = v => {
  const $0 = v.locale;
  const $1 = v.params;
  const $2 = v.schedules;
  return v1 => {
    if (v1.tag === "CustomProduct") {
      return Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure({price: Data$dMaybe.$Maybe("Just", Data$dRecord.unsafeGet("price")(v1._1)), errors: Data$dMaybe.Nothing});
    }
    if (v1.tag === "MenuProduct") {
      const $3 = v1._1;
      return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dV2$dMenuCatalogueQuery.askMenuCatalogue)(menu => {
        const v2 = Restaumatic$dMenu$dV2$dCartToOrder.cartProductToOrderItems(menu)($0)($2)($3)($1)(Data$dMap$dInternal.Leaf);
        if (v2.tag === "Right") {
          return Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure({
            price: Data$dMaybe.$Maybe("Just", v2._1._1.unitPrice),
            errors: Data$dMaybe.$Maybe("Just", Data$dEither.$Either("Right", v2._1._2))
          });
        }
        if (v2.tag === "Left") {
          return Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure({price: Data$dMaybe.Nothing, errors: Data$dMaybe.$Maybe("Just", Data$dEither.$Either("Left", v2._1))});
        }
        $runtime.fail();
      });
    }
    if (v1.tag === "MenuCombo") {
      const $3 = v1._1;
      return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dV2$dMenuCatalogueQuery.askMenuCatalogue)(menu => {
        const v2 = Restaumatic$dMenu$dV2$dCartToOrder.cartComboToOrderItems(menu)($0)($2)($3)($1);
        if (v2.tag === "Right") {
          return Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure({
            price: Data$dMaybe.$Maybe("Just", sum(Data$dFunctor.arrayMap(v3 => v3.unitPrice)(v2._1._1))),
            errors: Data$dMaybe.$Maybe("Just", Data$dEither.$Either("Right", v2._1._2))
          });
        }
        if (v2.tag === "Left") {
          return Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure({price: Data$dMaybe.Nothing, errors: Data$dMaybe.$Maybe("Just", Data$dEither.$Either("Left", v2._1))});
        }
        $runtime.fail();
      });
    }
    $runtime.fail();
  };
};
export {productPrice, sum};
